import useLiveOrders from "@/hooks/useLiveOrders";

/**
 * Mounts the live channel. Renders nothing.
 *
 * It is a component and not a call inside `_app` for the same reason
 * `AuthBootstrap` and `BackButtonBridge` are: `_app`'s own body sits OUTSIDE
 * `<Provider>`, so a hook that reads the store cannot live there. Mounted
 * inside `PersistGate` so the persisted staff session has already rehydrated —
 * the hook does nothing at all until `auth.isStaff` is true, and a check that
 * ran before rehydration would simply never fire.
 */
export default function LiveOrdersBridge() {
  useLiveOrders();
  return null;
}
